import { useContext } from "react";
import { MainContext } from "../App";
import { Col, Row, Statistic } from "antd";
import { ResourceHandler, ResourceType } from "../controllers/resources";
import { UserOutlined, ClockCircleOutlined } from "@ant-design/icons";
import "./WorldStats.css";

const WorldStats = () => {
  const { appState: context, setAppState: setContext } =
    useContext(MainContext);

  const { ageMax } = context.statistics;

  return (
    <div className="world-stats">
      <Row gutter={16}>
        <Col span={8}>
          <Statistic
            title="CYCLES"
            value={context.world.cycles}
            prefix={<ClockCircleOutlined />}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="CHARACTERS"
            value={context.world.characters.length}
            prefix={<UserOutlined />}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="DEADS"
            value={context.world.deads.length}
            prefix={<UserOutlined />}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Statistic
            title="PREYS"
            value={ResourceHandler.getTotalResources(
              context.world,
              ResourceType.ANIMAL_PREY
            )}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="YEAR"
            value={Math.floor(context.world.cycles / 12)}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="AGE MAX"
            value={ageMax.length > 0 ? ageMax[ageMax.length - 1].value : "N/A"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default WorldStats;
